import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  SecurityContext,
  ViewChild,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ContactPeople } from 'src/app/models/ContactPeople';
import { IContract } from 'src/app/models/ContractResponse';
import { ElectricitySupplyById } from 'src/app/models/ElectricitySupplyById';
import { EntityExistenceAndPermissions } from 'src/app/models/Entity';
import { IFile } from 'src/app/models/File';
import { History } from 'src/app/models/History';
import { LegalRepresentatives } from 'src/app/models/LegalRepresentatives';
import { ServerResponse } from 'src/app/models/ServerResponse';
import { ContractsService } from 'src/app/services/contracts.service';
import { EntitiesService } from 'src/app/services/entities.service';
import { GasSupplyById } from 'src/app/models/GasSupplyById';
import { EquipmentsViewComponent } from '../equipments-view/equipments-view.component';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, map, Observable, Subject, Subscription, switchMap, takeUntil, tap } from 'rxjs';
import { HistoryComparison } from 'src/app/models/HistoryComparison';
import { TranslateService } from '@ngx-translate/core';
import { HistoryDialogComponent } from '../history-dialog/history-dialog.component';
import { ButtonType, ColumnType, FilterOperator, FilterOptions, FilterOptionsType, ISColumn, ISLabelOptions, ISPagination, ISTabLayout, ISTableDatasource, SpinnerService } from 'is-lib';
import { SnackBarType } from 'src/app/models/Snackbar';
import { SnackBarService } from 'src/app/services/snackbar.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { IContractElectricitySupply } from 'src/app/models/ElectricitySupply';
import { IContractNaturalGasSupply } from 'src/app/models/NaturalGasSupply';
import { IContractSelfConsumptionSupply } from 'src/app/models/SelfConsumptionSupply';
import { LoaderConfig } from 'src/app/services/generic.service';
import { environment } from 'src/environments/environment';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-contracts-view',
  templateUrl: './contracts-view.component.html',
  styleUrls: ['./contracts-view.component.scss'],
})
export class ContractsViewComponent implements OnInit, OnDestroy {
	// TranslateService.stream never completes, so its subscription has to end with the component (and be replaced on each loadData)
	private readonly _destroy$ = new Subject<void>();
	private _translationsSubscription?: Subscription;

	selectedTab: number = 0;
	displayedColumns: string[] = ['TIN', 'NAME'];
	displayedColumnsContactPeople: string[] = [
		'TIN',
		'NAME',
		'ROLE',
		'CONTACT_DATA_DESIGNATION',
	];
	displayedColumnsElectricityPoints: string[] = [
		'CODE',
		'CONTRACTED_POWER',
		'TENSION_LEVEL',
		'DELIVERY_START_DATE',
		'DELIVERY_END_DATE',
		'COUNTY',
		'STATUS',
	];
	displayedColumnsNaturalGas: string[] = [
		'CODE',
		'DELIVERY_START_DATE',
		'DELIVERY_END_DATE',
		'STATUS',
	];
	displayedColumnsSelfConsumption: string[] = [
		'CODE',
		'POWER',
		'INSTALLATION_DATE',
		'CLIENT_REQUEST_INSTALLATION_DATE',
		'COUNTY',
		'STATUS',
	];
	displayedColumnsFiles: string[] = ['FILE', 'TYPE', 'CREATED', 'OPTIONS'];
	displayedColumnsHistory: string[] = [
		'TYPE',
		'MODIFICATION_DATE',
		'MODIFICATION_BY',
		'ACTIONS'
	];

  	contractStatesLabels = [
		{id: 'Pending', color: 'warning' },
		{id: 'Canceled', color: 'danger' },
		{id: 'Active', color: 'success' },
		{id: 'Accepted', color: 'success' },
		{id: 'InActivation', color: 'info' },
		{id: 'Inserted', color: 'info' },
		{id: 'PendingSupplier', color: 'warning' },
		{id: 'Terminated', color: 'danger' }
	]

	@ViewChild(MatPaginator) paginator!: MatPaginator;
	@ViewChild('filesTable') filesTable!: MatTable<File>;

	tabLayout$!: BehaviorSubject<ISTabLayout>; //object with tabs

	electricitySuppliesDataSource$: BehaviorSubject<ISTableDatasource> | undefined
	naturalGasSuppliesDataSource$: BehaviorSubject<ISTableDatasource> | undefined
	selfConsumptionSuppliesDataSource$: BehaviorSubject<ISTableDatasource> | undefined
	contactPeopleDataSource$: BehaviorSubject<ISTableDatasource> | undefined
	legalRepresentativesDataSource$: BehaviorSubject<ISTableDatasource> | undefined
	filesDataSource$: BehaviorSubject<ISTableDatasource> | undefined
	historyDataSource$: BehaviorSubject<ISTableDatasource> | undefined


	contactPeopleDataSource: MatTableDataSource<ContactPeople>;
	legalRepresentativesDataSource: MatTableDataSource<LegalRepresentatives>;
	electricitySuppliesDataSource: MatTableDataSource<IContractElectricitySupply>;
	gasSuppliesDataSource: MatTableDataSource<IContractNaturalGasSupply>;
	selfConsumptionSuppliesDataSource: MatTableDataSource<IContractSelfConsumptionSupply>;
	filesDataSource: MatTableDataSource<File>;
	historyDataSource: MatTableDataSource<History>;
	
	entity!: EntityExistenceAndPermissions;
	contract!: IContract;

	spinnerTrack = {};

	constructor(
		private _activatedRoute: ActivatedRoute,
		private _contractsService: ContractsService,
		private _entitiesService: EntitiesService,
		private _dialog: MatDialog,
		private _router: Router,
		private _sanitizer: DomSanitizer,
		private http: HttpClient,
		private _translateService: TranslateService,
		private _clipBoard: Clipboard,
		private _snackbar: SnackBarService,
		protected _spinnerService: SpinnerService,
		private _userService: UsersService
	) {
		this.legalRepresentativesDataSource = new MatTableDataSource<LegalRepresentatives>();
		this.electricitySuppliesDataSource = new MatTableDataSource<IContractElectricitySupply>();
		this.selfConsumptionSuppliesDataSource = new MatTableDataSource<IContractSelfConsumptionSupply>();
		this.gasSuppliesDataSource = new MatTableDataSource<IContractNaturalGasSupply>();
		this.filesDataSource = new MatTableDataSource<File>();
		this.contactPeopleDataSource = new MatTableDataSource<ContactPeople>();
		this.historyDataSource = new MatTableDataSource<History>();
	}

	ngOnInit(): void {
		this._activatedRoute.params.subscribe((res) => {
			if (res['id']) {
				this.fetchContractData(res['id']);
			}
		});

	}

	ngOnDestroy(): void {
		this._destroy$.next();
		this._destroy$.complete();
	}

	loadData(): void {
		let selectedMenu = 0;

		this._translationsSubscription?.unsubscribe();
		this._translationsSubscription = this._translateService.stream([
			'CLIENT_INFO', 'CONTRACT_DATA', 'OTHER_DATA', 'HISTORY',
			'CODE', 'TENSION_LEVEL', 'DELIVERY_START_DATE', 'DELIVERY_END_DATE', 'STATUS', 'COUNCIL', 'PRESSURE_LEVEL', 'TIER', 'TARIFF_OPTION', 'COUNTY', 'INSTALLATION_DATE', 'ACTIVATION_DATE', 'POWER',
			'EQUIPMENT_STATUS.PENDING', 'EQUIPMENT_STATUS.CANCELED', 'EQUIPMENT_STATUS.ACTIVE', 'EQUIPMENT_STATUS.ACCEPTED', 'EQUIPMENT_STATUS.INACTIVATION', 'EQUIPMENT_STATUS.INSERTED', 'EQUIPMENT_STATUS.PENDING_SUPPLIER', 'EQUIPMENT_STATUS.TERMINATED'
		]).pipe(takeUntil(this._destroy$)).subscribe((translations: any) => {
			this.tabLayout$ = new BehaviorSubject<ISTabLayout>({
				selectedMenu: selectedMenu,
				tabItems: [
					{ id: 0, label: translations['CLIENT_INFO'] },
					{ id: 1, label: translations['CONTRACT_DATA'] },
					{ id: 2, label: translations['OTHER_DATA'] },
					{ id: 3, label: translations['HISTORY'] },
				],
				verticalLayout: false
			});

			this.electricitySuppliesDataSource$ = new BehaviorSubject<ISTableDatasource>(
				new ISTableDatasource(
					[
						new ISColumn('electricityMeterCode', translations['CODE'], new FilterOptions('', FilterOptionsType.text, FilterOperator.contains, 'FkCPENavigation', 'CPE1'), ColumnType.text),
						new ISColumn('tensionLevel', translations['TENSION_LEVEL'], new FilterOptions('', FilterOptionsType.text, FilterOperator.contains), ColumnType.text, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
							'$contractedPower|number|emptyCheck: kVA$'),
						new ISColumn('deliveryStartDate', translations['DELIVERY_START_DATE'], new FilterOptions('', FilterOptionsType.dateRange, FilterOperator.between, undefined, 'DeliveryStartDate', 'ClientRequestedDeliveryStartDate'), ColumnType.dateRange),
						new ISColumn('deliveryEndDate', translations['DELIVERY_END_DATE'], new FilterOptions('', FilterOptionsType.dateRange, FilterOperator.between, undefined, 'DeliveryEndDate'), ColumnType.dateRange),
						new ISColumn('status', translations['STATUS'], new FilterOptions('', FilterOptionsType.select, FilterOperator.equals), ColumnType.labels, undefined, undefined, undefined, undefined,
							[
								new ISLabelOptions('Pending', translations['EQUIPMENTS_STATUS.PENDING'], 'warning'),
								new ISLabelOptions('Canceled', translations['EQUIPMENTS_STATUS.CANCELED'], 'danger'),
								new ISLabelOptions('Active', translations['EQUIPMENTS_STATUS.ACTIVE'], 'primary'),
								new ISLabelOptions('Accepted', translations['EQUIPMENTS_STATUS.ACCEPTED'], 'success'),
								new ISLabelOptions('InActivation', translations['EQUIPMENTS_STATUS.INACTIVATION'], 'secondary'),
								new ISLabelOptions('Inserted', translations['EQUIPMENTS_STATUS.INSERTED'], 'info'),
								new ISLabelOptions('PendingSupplier', translations['EQUIPMENTS_STATUS.PENDING_SUPPLIER'], 'light-warning'),
								new ISLabelOptions('Terminated', translations['EQUIPMENTS_STATUS.TERMINATED'], 'dark')
							]
						),
						new ISColumn('electricityMeterCounty', translations['COUNTY'], new FilterOptions('', FilterOptionsType.text, FilterOperator.contains, 'FkCPENavigation.FkAddressNavigation.FkPostalCodeNavigation.FkLocalityNavigation.FkCountyNavigation', 'Name'))
					],
					[],
					undefined,
					false,
					new ISPagination(10, 1),
					0,
					`${environment.apiUrl}ClientPortalUsers/${this._userService.userCountryCode}/Mine/Contracts/${this.contract.guidId}/ElectricitySupplies/Get`
				)
			)

			this.naturalGasSuppliesDataSource$ = new BehaviorSubject<ISTableDatasource>(
				new ISTableDatasource(
					[
						new ISColumn('naturalGasMeterCode', translations['CODE'], new FilterOptions('', FilterOptionsType.text, FilterOperator.contains, 'FkCPENavigation', 'CPE1'), ColumnType.text, 'min-w-150px'),
						new ISColumn('pressureLevel', translations['PRESSURE_LEVEL'], new FilterOptions('', FilterOptionsType.text, FilterOperator.contains), ColumnType.text),
						new ISColumn('rating', translations['TIER'], undefined, ColumnType.text),
						new ISColumn('deliveryStartDate', translations['DELIVERY_START_DATE'], new FilterOptions('', FilterOptionsType.dateRange, FilterOperator.between, undefined, 'DeliveryStartDate', 'ClientRequestedDeliveryStartDate'), ColumnType.text),
						new ISColumn('deliveryEndDate', translations['DELIVERY_END_DATE'], new FilterOptions('', FilterOptionsType.dateRange, FilterOperator.between, undefined, 'DeliveryEndDate'), ColumnType.dateRange),
						new ISColumn('status', translations['STATUS'], new FilterOptions('', FilterOptionsType.select, FilterOperator.equals), ColumnType.labels, 'min-w-150px', undefined, undefined, undefined,
							[
								new ISLabelOptions('Pending', translations['EQUIPMENTS_STATUS.PENDING'], 'warning'),
								new ISLabelOptions('Canceled', translations['EQUIPMENTS_STATUS.CANCELED'], 'danger'),
								new ISLabelOptions('Active', translations['EQUIPMENTS_STATUS.ACTIVE'], 'primary'),
								new ISLabelOptions('Accepted', translations['EQUIPMENTS_STATUS.ACCEPTED'], 'success'),
								new ISLabelOptions('InActivation', translations['EQUIPMENTS_STATUS.INACTIVATION'], 'secondary'),
								new ISLabelOptions('Inserted', translations['EQUIPMENTS_STATUS.INSERTED'], 'info'),
								new ISLabelOptions('PendingSupplier', translations['EQUIPMENTS_STATUS.PENDING_SUPPLIER'], 'light-warning'),
								new ISLabelOptions('Terminated', translations['EQUIPMENTS_STATUS.TERMINATED'], 'dark')
							]
						),
						new ISColumn('naturalGasMeterCounty', translations['COUNTY'], new FilterOptions('', FilterOptionsType.dateRange, FilterOperator.between, 'FkFileNavigation', 'Created'), ColumnType.dateRange),
					],
					[],
					[],
					false,
					new ISPagination(10, 1),
					0,
					`${environment.apiUrl}ClientPortalUsers/${this._userService.userCountryCode}/Mine/Contracts/${this.contract.guidId}/NaturalGasSupplies/Get`
				)
			)

			this.selfConsumptionSuppliesDataSource$ = new BehaviorSubject<ISTableDatasource>(
				new ISTableDatasource(
					[
						new ISColumn('electricityMeterCode', translations['CODE'], new FilterOptions('', FilterOptionsType.text, FilterOperator.contains, 'FkCPENavigation', 'CPE1'), ColumnType.text, 'min-w-150px'),
						new ISColumn('installationDate', translations['INSTALLATION_DATE'], new FilterOptions('', FilterOptionsType.dateRange, FilterOperator.between, undefined, 'InstallationDate', 'ClientRequestedInstallationDate'), ColumnType.date),
						new ISColumn('activationDate', translations['ACTIVATION_DATE'], new FilterOptions('', FilterOptionsType.dateRange, FilterOperator.between), ColumnType.date),
						new ISColumn('power', translations['POWER'], new FilterOptions('', FilterOptionsType.number, FilterOperator.contains), ColumnType.number, undefined, undefined, undefined, undefined, undefined, undefined, ' kW'),
						new ISColumn('electricityMeterCounty', translations['COUNTY'], new FilterOptions('', FilterOptionsType.text, FilterOperator.contains, 'FkCPENavigation;FkAddressNavigation;FkPostalCodeNavigation;FkLocalityNavigation;FkCountyNavigation', 'Name'), ColumnType.text),
						new ISColumn('status', translations['STATUS'], new FilterOptions('', FilterOptionsType.select, FilterOperator.equals), ColumnType.labels, 'min-w-150px', undefined, undefined, undefined,
							[
								new ISLabelOptions('Pending', translations['EQUIPMENTS_STATUS.PENDING'], 'warning'),
								new ISLabelOptions('Canceled', translations['EQUIPMENTS_STATUS.CANCELED'], 'danger'),
								new ISLabelOptions('Active', translations['EQUIPMENTS_STATUS.ACTIVE'], 'primary'),
								new ISLabelOptions('Accepted', translations['EQUIPMENTS_STATUS.ACCEPTED'], 'success'),
								new ISLabelOptions('InActivation', translations['EQUIPMENTS_STATUS.INACTIVATION'], 'secondary'),
								new ISLabelOptions('Inserted', translations['EQUIPMENTS_STATUS.INSERTED'], 'info'),
								new ISLabelOptions('PendingSupplier', translations['EQUIPMENTS_STATUS.PENDING_SUPPLIER'], 'light-warning'),
								new ISLabelOptions('Terminated', translations['EQUIPMENTS_STATUS.TERMINATED'], 'dark')
							]
						)
					],
					[],
					[],
					false,
					new ISPagination(10, 1),
					0,
					`${environment.apiUrl}ClientPortalUsers/${this._userService.userCountryCode}/Mine/Contracts/${this.contract.guidId}/SelfConsumptionContracts/Get`
				)
			)
		});
	}

	fetchContractData(contractId: string) {
		this._contractsService
			.getContract(contractId, true).pipe( 
				tap( (sr_contract) => this.contract = sr_contract.data ),
				switchMap((sr_contract) => 
					forkJoin({
						entity: this.getEntityRequest(sr_contract.data.entity.tin.toString()),
						contactPeople: this.getContactPeopleRequest(sr_contract.data.guidId)
					})
				)
			)
			.subscribe( (sr_entityContactPeople) => {
				this.loadData();
				this.entity = sr_entityContactPeople.entity;
				this.legalRepresentativesDataSource.data = sr_entityContactPeople.entity.legalRepresentatives;
				this.contactPeopleDataSource.data = sr_entityContactPeople.contactPeople;
			})
	}

	getEntityRequest(entityTIN: string): Observable<any> {
		return this._entitiesService.getEntityByTin(entityTIN, undefined, true).pipe(
			switchMap( (sr_entity) => 
				this._entitiesService.getLegalRepresentatives(sr_entity.data.id, undefined, new LoaderConfig(true, false, 'LegalRepresentatives')).pipe(
					map( (sr_entityLegalRepresentatives) =>({
						...sr_entity.data,
						legalRepresentatives: sr_entityLegalRepresentatives.data
					}))
				)
			)
		)
	}

	getContactPeopleRequest(contractId: string) {
		return this._contractsService.getContractContactPeople(contractId, undefined, new LoaderConfig(true, false, 'ContactPeople')).pipe(
			map( (sr_contactPeople) => sr_contactPeople.data)
		)
	}

	getContractFilesRequest(contractId: string) {
		return this._contractsService.getContractFiles(contractId, undefined, new LoaderConfig(true, false, 'Files')).pipe(
			map( (sr_contractFiles) => sr_contractFiles.data )
		)
	}

	getEquipmentsRequest(contractId: string) {
		return forkJoin({
		electricity: this._contractsService.getContractElectricitySupplies(contractId, undefined, new LoaderConfig(true, false, 'ContractElectricitySupplies')).pipe(
			map(sr_electricity => sr_electricity.data)
		),
		naturalGas: this._contractsService.getContractNaturalGasSupplies(contractId, undefined, new LoaderConfig(true, false, 'ContractNaturalGasSupplies')).pipe(
			map(sr_naturalGas => sr_naturalGas.data)
		),
		selfConsumption: this._contractsService.getContractSelfConsumptionSupplies(contractId, undefined, new LoaderConfig(true, false, 'ContractSelfConsumptionSupplies')).pipe(
			map(sr_selfConsumption => sr_selfConsumption.data)
		)
		})
	}

	getContractHistoryRequest(contractId: string) {
		return this._contractsService.getContractHistory(contractId, undefined, new LoaderConfig(true, false, 'History')).pipe(
			map( sr_history => sr_history.data )
		)
	}

	equipmentClick(equipment: any, type: string) {
		if (type == 'electricity') {
			this._dialog.open(EquipmentsViewComponent, {
				width: '90vw', // 90% of the viewport width
				maxWidth: '1000px', // Maximum width for larger screens
				height: '80vh', // 80% of the viewport height
				maxHeight: '900px', // Maximum height for larger screens
				panelClass: 'responsive-dialog', // Optional: Add a custom class for additional styling
				data: { electricityDetail: equipment, contractId: this.contract.guidId },
			});
		} else if (type == 'naturalGas') {
			this._dialog.open(EquipmentsViewComponent, {
				width: '90vw', // 90% of the viewport width
				maxWidth: '1000px', // Maximum width for larger screens
				height: '80vh', // 80% of the viewport height
				maxHeight: '900px', // Maximum height for larger screens
				panelClass: 'responsive-dialog', // Optional: Add a custom class for additional styling
				data: { gasDetail: equipment, contractId: this.contract.guidId },
			});
		} else if (type == 'selfConsumption') {
			this._dialog.open(EquipmentsViewComponent, {
				width: '90vw', // 90% of the viewport width
				maxWidth: '1000px', // Maximum width for larger screens
				height: '80vh', // 80% of the viewport height
				maxHeight: '900px', // Maximum height for larger screens
				panelClass: 'responsive-dialog', // Optional: Add a custom class for additional styling
				data: { selfConsumptionDetail: equipment, contractId: this.contract.guidId },
			});
		}
	}

	historyClick(historyId: string) {
		this._dialog.open(HistoryDialogComponent, {
			width: '90vw', // 90% of the viewport width
			maxWidth: '1000px', // Maximum width for larger screens
			height: '80vh', // 80% of the viewport height
			maxHeight: '200px', // Maximum height for larger screens
			panelClass: 'responsive-dialog', // Optional: Add a custom class for additional styling
			data: { contractId: this.contract.guidId, historyId: historyId },
		});
	}

	viewFile(row: IFile) {
		if (row.type.includes('image')) {
			this._dialog.open(FileViewerComponent, {
				data: { dataType: 'image', file: row.path },
			});
		} else {
			this._dialog.open(FileViewerComponent, {
				data: { dataType: 'pdf', file: row.path },
			});
		}
	}

	copyToClipBoard(message: any): void {
		if (message != null && message != '') {
			this._clipBoard.copy(message);
			this._snackbar.callSnackBar('COPIED', SnackBarType.SUCCESS)
		}
	}

	onTabChange(selectedTab: number) {
		this.selectedTab = selectedTab;

		switch(selectedTab) {
			case 1: 
				this.getEquipmentsRequest(this.contract.guidId).subscribe( (sr_equipments) => {
					this.electricitySuppliesDataSource.data = sr_equipments.electricity;
					this.gasSuppliesDataSource.data = sr_equipments.naturalGas;
					this.selfConsumptionSuppliesDataSource.data = sr_equipments.selfConsumption;
				});
				break;
			case 2:
				this.getContractFilesRequest(this.contract.guidId).subscribe( (sr_files) => {
					this.filesDataSource.data = sr_files;
				});
				break;
			case 3:
				this.getContractHistoryRequest(this.contract.guidId).subscribe( (sr_history) => {
					this.historyDataSource.data = sr_history;
				});
				break;
		}
	}

	download(url: string): Observable<Blob> {
		return this.http.get(url, {
		responseType: 'blob'
		})
	}

	onDownloadFile(row: IFile) {
		// var fileURL = row.path;
		// let tab = window.open(fileURL, '_blank');

		// this.download(row.path)
		//   .subscribe(blob => {
		//     const a = document.createElement('a')
		//     const objectUrl = row.path;
		//     a.href = objectUrl
		//     a.download = row.name;
		//     a.click();
		//     URL.revokeObjectURL(objectUrl);
		//   })

		// const data = 'some text';
		// this.blob = new Blob([data], { type: 'application/octet-stream' });

		// let fileUrl: SafeResourceUrl | null = null;
		// const data = row.path;
		// const blob = new Blob([data], { type: 'application/pdf' });

		// this.fileSrc = this._sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));


		// this.fileSrc = this._sanitizer.bypassSecurityTrustResourceUrl(row.path);

		// const blob = new Blob([row.path], { type: 'application/pdf' });

		// const a = document.createElement('a');
		// document.body.appendChild(a);
		// const url = window.URL.createObjectURL(blob);
		// a.href = row.path;
		// a.download = row.name;
		// a.click();
		// setTimeout(() => {
		//   window.URL.revokeObjectURL(url);
		//   document.body.removeChild(a);
		// }, 0);
		// downloadFile() {
		//   this.blob.saveFile(this.fileName);
		// }
	}

	getStatusColor(status: string) {
		return this.contractStatesLabels.find( (statusLabel) => statusLabel.id == status )?.color;
	}
}


@Component({ 
  template: `
    <div *ngIf="imageSrc != null">
      <img [src]="imageSrc" style="max-width: 90vw; max-height: 90vh" />
    </div>
    <div *ngIf="fileSrc != null">
      <iframe
        style="max-width: 90vw; max-height: 90vh;width: 90vw; height: 90vh"
        type="application/pdf"
        [src]="fileSrc"
      ></iframe>
    </div>
  `,
})

export class FileViewerComponent implements OnInit {
  constructor(
    private readonly dialogRef: MatDialogRef<FileViewerComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: any,
    private _sanitizer: DomSanitizer
  ) {}

  imageSrc: string | null = null;
  fileSrc: SafeResourceUrl | null = null;

  ngOnInit(): void {
    if (this.data) {
      if (this.data.dataType == 'image') {
        let fileReader = new FileReader();

        fileReader.readAsDataURL(this.data.file);

        fileReader.onload = () => {
          let safeUrl = this._sanitizer.sanitize(
            SecurityContext.URL,
            fileReader.result!.toString()
          );

          if (!String.isNullOrUndefinedOrWhitespace(safeUrl)) {
            this.imageSrc = safeUrl;
          } else {
            this.imageSrc = null;
          }
        };

        fileReader.onerror = fileReader.onabort = () => {
          this.imageSrc = null;
        };
      } else if (this.data.dataType == 'pdf') {
        this.fileSrc = this._sanitizer.bypassSecurityTrustResourceUrl(this.data.file);
      }
    }
  }
}
